import { selectCognitoUserObject } from 'utils/cognito.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { isEnvCy } from 'utils/env/determine.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isFn from 'utils/predicates/function/isFn.util';

import AT from './verifyCode.type';

const L = logger('verifyCode');

const ATTRIBUTE = 'phone_number';

// noinspection DuplicatedCode
const mockVerifyCode = () => (dispatch) => {
  const data = '';

  dispatch(L.debug('mockVerifyCode()', 'init:', { type: AT.init }));
  dispatch(L.debug('mockVerifyCode()', 'pass:', { type: AT.pass, data }));
  dispatch(L.debug('mockVerifyCode()', 'done:', { type: AT.done }));

  return Promise.resolve(data);
};

// FIXME: mocking should be part of the Cypress tests not the regular code
const verifyCode = isEnvCy()
  ? mockVerifyCode
  : (options) => (dispatch, getState) => {
      // SEE: https://www.npmjs.com/package/amazon-cognito-identity-js
      // SEE: https://github.com/aws-amplify/amplify-js

      const { code } = asObject(options);
      dispatch({ type: AT.init });

      const user = selectCognitoUserObject(getState());
      const confirmationCode = Array.isArray(code) ? code.join('') : fromAnyToString(code);

      const promise = new Promise((onSuccess, onFailure) => {
        try {
          if (isFn(user && user.verifyAttribute)) {
            user.verifyAttribute(ATTRIBUTE, confirmationCode, { onSuccess, onFailure });
          } else {
            onFailure(new Error("Can't verify, maybe not logged in or invalid user:", user));
          }
        } catch (e) {
          onFailure(e);
        }
      });

      promise
        .then((message) => dispatch({ type: AT.pass, data: L.debug('()', 'then()', message) }))
        .catch((e) => dispatch({ type: AT.fail, data: L.warn('()', 'catch()', { code, user }, e) }))
        .finally(() => dispatch({ type: AT.done }));

      return promise;
    };

// noinspection JSUnusedGlobalSymbols
export default verifyCode;
